<div class="card shadow">
  @if (header) {
    <div class="card-header color-blue">{{header}}</div>
  }
  <div class="card-body">
    <div ngbDropdown [ngClass]="{'d-none' : !hasActions}">
      <button class="btn btn-circle btn-light float-end" ngbDropdownToggle><fa-icon [icon]="faEllipsisV"></fa-icon></button>
      <div ngbDropdownMenu #actionsWrapper>
        <ng-content></ng-content>
      </div>
    </div>
    <div class="d-flex">
      <div class="w-25 me-3">
        <div class="photo" [style.backgroundImage]="'url(' + (photo || 'assets-front/images/avatar-default.png') + ')'"></div>
      </div>
      <div>
        <h5 class="card-title color-blue">{{name}}</h5>
        <h6 class="card-text">{{job}}</h6>
        @if (phone) {
          <h6 class="card-text">{{phone}}</h6>
        }
        @if (email) {
          <h6 class="card-text">{{email}}</h6>
        }
        @if (site) {
          <a [routerLink]="" (click)="goToLink(site)" href="{{site}}">{{site}}</a>
        }
      </div>
    </div>
    <div class="btn-group d-block text-center mt-5">
      @if (phone) {
        <a class="btn btn-blue w-33 btn-contact-card" [href]="('tel:' + phone) | bypassSecurityTrustUrl" matomoClickCategory="Contacts" matomoClickAction="click" matomoClickName="contact_joindre_telephone"><div class="picto phone"></div>Tél</a>
      }
      @if (email) {
        <a class="btn btn-orange w-33 btn-contact-card" [href]="('mailto:' + email) | bypassSecurityTrustUrl" matomoClickCategory="Contacts" matomoClickAction="click" matomoClickName="contact_joindre_email"><div class="picto email"></div>Email</a>
      }
      @if (phone) {
        <a class="btn btn-blue w-33 btn-contact-card" [href]="('sms:' + phone) | bypassSecurityTrustUrl" matomoClickCategory="Contacts" matomoClickAction="click" matomoClickName="contact_joindre_sms"><div class="picto sms"></div>SMS</a>
      }
    </div>
  </div>
</div>
